import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import LayoutShell from './components/LayoutShell';
import HomePage from './pages/HomePage';
import DetailPage from './pages/DetailPage';
import ApiPortalPage from './pages/ApiPortalPage';
import ConsultationPage from './pages/ConsultationPage';
import { detailPages } from './data/siteContent';

const theme = createTheme({
  palette: {
    primary: { main: '#1e40af' },
    secondary: { main: '#0f766e' },
    background: { default: '#f5f8ff' }
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: '"IBM Plex Sans", "PingFang SC", "Microsoft YaHei", sans-serif',
    h2: { fontWeight: 800 },
    h3: { fontWeight: 800 }
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LayoutShell>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<DetailPage page={detailPages.about} />} />
          <Route path="/services" element={<DetailPage page={detailPages.services} />} />
          <Route path="/solutions" element={<DetailPage page={detailPages.solutions} />} />
          <Route path="/cases" element={<DetailPage page={detailPages.cases} />} />
          <Route path="/advantages" element={<DetailPage page={detailPages.advantages} />} />
          <Route path="/faq" element={<DetailPage page={detailPages.faq} />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/api-web" element={<ApiPortalPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </LayoutShell>
    </ThemeProvider>
  );
}

export default App;
